import type { ReactNode } from 'react'
import { Button } from '@/components/Button'
import { useNavigate } from 'react-router'
import styles from './JobNavigation.module.css'

interface JobNavigationProps {
  next?: string
  canProceed?: boolean
  primaryAction?: ReactNode
  secondaryAction?: ReactNode
}

export function JobNavigation({
  next,
  canProceed,
  primaryAction,
  secondaryAction,
}: JobNavigationProps) {
  const navigate = useNavigate()

  return (
    <div className={styles.root}>
      <div className={styles.buttonContainer}>{secondaryAction}</div>

      <div className={styles.buttonContainer}>
        {next && (
          <Button
            label="Next"
            onPress={() => navigate(next)}
            isDisabled={!canProceed}
            variant="primary"
          />
        )}

        {primaryAction}
      </div>
    </div>
  )
}
